import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})

export class ReportsDataService {
    constructor(private http: HttpClient) {
    }

    // Companies
    getCompaniesNumber() {
        return this.http.get('/agri/crm/numberCompanies');
    }

    // Projects
    getAllProjectsNumber() {
        return this.http.get('/agri/crm/numberAllProjects');
    }

    getProjectByStatus(status: string) {
        return this.http.get('/agri/crm/numberProjectsByStatus?statusProject=' + status);
    }

    // Offers
    getOffersNumber() {
        return this.http.get('/agri/crm/numberAllOffers');
    }

    getOffersByStatus(status: string) {
        return this.http.get('/agri/crm/numberOffersByStatus?statusOffer=' + status);
    }

    // Jobs
    getAllJobs() {
        return this.http.get('/agri/crm/numberAllJobs');
    }

    getAllActiveJobs() {
        return this.http.get('/agri/crm/numberActiveJobs');
    }

    // Candidates
    getCandidates() {
        return this.http.get('/agri/crm/numberCandidates');
    }

    // Contracts
    getAllContracts() {
        return this.http.get('/agri/crm/numberAllContracts');
    }

    getContractsByStatus(status: string) {
        return this.http.get('/agri/crm/numberContractsByStatus?statusContract=' + status)
    }

}
